import type { MouseEventHandler } from 'react';

export interface AccessibilityProps {
  /** Indicates whether an element's live region should be treated as atomic */
  'aria-atomic'?: boolean | 'true' | 'false';

  /** Provides a reference to the element that this element controls */
  'aria-controls'?: string;

  /** Provides a text alternative for elements that have no visible text  */
  'aria-label'?: string;

  /** Provides a reference to a text alternative for elements that have no visible text  */
  'aria-labelledby'?: string;

  /** Indicates that an element will be updated. */
  'aria-live'?: 'assertive' | 'off' | 'polite';

  /** Sets the pressed state of the element */
  'aria-pressed'?: boolean;

  /** Provides a text alternative for elements that have no visible text  */
  ariaLabel?: string;

  /** Provides a a reference to a text alternative for elements that have no visible text  */
  ariaLabelledBy?: string;

  /** Sets the role of the element */
  role?: string;
}

/**
 * Check accessibility for components that have action-related roles.
 * Return object of accessibility props, mapped to their appropriate html attributes.
 *
 * See: https://dequeuniversity.com/rules/axe/4.1/aria-command-name
 */
export function getAccessibilityProps({
  ariaLabel,
  ariaLabelledBy,
  'aria-live': ariaLive,
  role: roleProp,
  onClick,
}: AccessibilityProps & { onClick?: MouseEventHandler }) {
  const role = onClick ? 'button' : roleProp;

  return {
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy,
    'aria-live': ariaLive,
    role,
  };
}
